import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Badge, Card, Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import Select from "react-select";
import { createBusApi, getBusListApi } from "../../services/TransportService";
import { MdHistory } from "react-icons/md";
import { FaBusSimple } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { FaRegUser } from "react-icons/fa";
import { GoArrowSwitch } from "react-icons/go";
import { MdReduceCapacity, MdModeOfTravel } from "react-icons/md";
import { CustomTooltip } from "../../components/CustomTooltip";
import { FaRegEdit } from "react-icons/fa";
import { Offcanvas } from "react-bootstrap";
import { getlivestatus } from "../../services/TransportService";
import {
  busstatusoption,
  getBusStatusBadge,
  modeloption,
} from "../../utilities";
import { deviceidoption } from "../../utilities";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useWindowWidth } from "../../utilities";
import TripList from "../Route/Trip/TripList";
import Bustrip from "./Bustrip";
import BusTripLogs from "./BusTripLogs";
import BusReplacementLog from "./BusReplacementLogs";
import BusActiveEmployee from "./BusActiveEmployee";
function BusListPage({ userRole }) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const [errormsg, setErrormsg] = useState("");
  const [buslistError, setBusListError] = useState("");
  const [selectedStatus, setSelecetdStatus] = useState(busstatusoption[0]);
  const [selectedActionType, setSelectedActiontype] = useState("");
  const [selectedBus, settSelectedBus] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [refreshingBusId, setRefreshingBusId] = useState(null);
  const handlesidebar = () => {
    if (showSidebar) {
      setSelectedActiontype("");
    }
    setShowSidebar((prev) => !prev);
  };
  const width = useWindowWidth();
  const [addFormFields, setAddFormFields] = useState({
    number_plate: "",
    capacity: 40,
    model: "",
    monthly_travel_distance: "",
    // is_active: false,
  });
  const [errordata, setErrordata] = useState({
    number_plate: "",
    capacity: "",
    model: "",
    monthly_travel_distance: "",
  });
  const recordsPage = 10;
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    // page: 1,
    // page_size: 12,
    query: "",
    status: "",
  });
  const [modalVisible, setModalVisible] = useState(false);

  const fetchData = () => {
    setIsLoading(true);
    getBusListApi(filter)
      .then((resp) => {
        setData(resp?.data?.data || []);
        setTotal(resp.data?.count || 0);
        setBusListError("");
      })
      .catch((error) => {
        setBusListError(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Please try again later"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  const handlePageChange = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page,
    }));
  };

  const handleSearchChange = (value) => {
    setFilter((prev) => ({
      ...prev,
      page: 1,
      query: value,
    }));
  };

  const handleToggleModal = () => {
    if (modalVisible) {
      setErrormsg("");
      setAddFormFields({
        number_plate: "",
        capacity: 40,
        is_active: false,
        monthly_travel_distance: "",
        model: "",
      });
      setErrordata({
        number_plate: "",
        capacity: "",
        model: "",
        monthly_travel_distance: "",
      });
    }
    setModalVisible((prev) => !prev);
  };

  const handleSubmit = () => {
    setIsAddSubmiting(true);
    createBusApi(addFormFields)
      .then((resp) => {
        setData((prev) => [resp.data.data, ...prev]);
        setTotal((prev) => prev + 1);
        toast.success("Created successfully");
        handleToggleModal();
      })
      .catch((error) => {
        setErrormsg(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Please try again later"
        );
      })
      .finally(() => {
        setIsAddSubmiting(false);
      });
  };
  useEffect(() => {
    if (errormsg) {
      const timeout = setTimeout(() => {
        setErrormsg("");
      }, 9000);
      return () => clearTimeout(timeout); // cleanup if component unmounts or errormsg changes early
    }
  }, [errormsg]);
  const handleadd = () => {
    let valid = true;
    const error = {
      number_plate: "",
      capacity: "",
      model: "",
      monthly_travel_distance: "",
    };
    if (!addFormFields.number_plate) {
      error.number_plate = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields.capacity) {
      error.capacity = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields.model) {
      error.model = "Manadatory Field";
      valid = false;
    }
    if (!addFormFields.monthly_travel_distance) {
      error.monthly_travel_distance = "Mandatory Field";
      valid = false;
    }
    setErrordata(error);
    if (valid) {
      handleSubmit();
      // console.log(addFormFields);
    }
  };
  const actionComponents = {
    trips: <Bustrip busId={selectedBus?.id} />,
    "trip log": <BusTripLogs busId={selectedBus?.id} />,
    "replacement log": <BusReplacementLog busId={selectedBus?.id} />,
    "active passes": <BusActiveEmployee busId={selectedBus?.id} />,
  };
  const handleClickRefresh = (bus) => {
    if (refreshingBusId === bus.id) return; // prevent duplicate click

    setRefreshingBusId(bus.id);

    getlivestatus(bus.id)
      .then((res) => {
        const updatedData = data.map((b) =>
          b.id === bus.id ? { ...b, ...res?.data?.data } : b
        );
        setData(updatedData);
        toast.success("Retrieved Successfully");
      })
      .catch(() => toast.error("Failed to retrieve data."))
      .finally(() => setRefreshingBusId(null));
  };

  useEffect(() => {
    setFilter({ ...filter, status: selectedStatus?.value || "" });
  }, [selectedStatus]);
  return (
    <>
      {buslistError ? (
        <div className="alert alert-danger">{buslistError}</div>
      ) : (
        <div>
          <Block.Head>
            <Block.HeadBetween>
              <Block.HeadContent>
                <Block.Title tag="h2">Buses</Block.Title>
                <nav>
                  <ol className="breadcrumb breadcrumb-arrow mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Buses
                    </li>
                  </ol>
                </nav>
              </Block.HeadContent>

              <Block.HeadContent>
                <ul className="d-flex">
                  <li className="me-2">
                    <DebounceSearchInput
                      handleSearchChange={handleSearchChange}
                      placeholder="Search Bus.."
                    />
                  </li>
                  <li className="me-2">
                    <Select
                      options={busstatusoption}
                      onChange={setSelecetdStatus}
                      placeholder="Select status"
                      className="react-select"
                      classNamePrefix="select"
                      isClearable
                      value={selectedStatus}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 999,
                        }),
                      }}
                    />
                  </li>
                  <li>
                    {userRole === "Admin" && (
                      <Button
                        className="d-md-inline-flex"
                        variant="primary"
                        onClick={handleToggleModal}
                      >
                        <Icon name="plus" />
                        <span>Add Bus</span>
                      </Button>
                    )}
                  </li>
                </ul>
              </Block.HeadContent>
            </Block.HeadBetween>
          </Block.Head>
          <Block>
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center p-3">
                <Spinner animation="border" size="sm" />
                <span className="ms-1">Loading...</span>
              </div>
            ) : data?.length > 0 ? (
              <Row>
                <div className="d-flex flex-column gap-2">
                  {data.map((item, index) => (
                    <>
                      {/* <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}
                    className="mb-3"
                  > */}

                      {/* <Card className="card-hover-shadow">
                      <Card.Body className="p-0">
                        <div className="d-flex flex-column gap-2 p-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5>{item.number_plate}</h5>
                            <span className={getBusStatusBadge(item?.status)}>
                              {item?.status}
                            </span>
                          </div>
                          <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <h6>Capacity: {item?.capacity}</h6>
                            <Link
                              to={`/bus/${item.id}`}
                              className="btn btn-outline-primary btn-sm"
                            >
                              Details{" "}
                              <Icon className={"ms-1"} name="arrow-right" />
                            </Link>
                          </div>
                        </div>
                      </Card.Body>
                    </Card> */}

                      <div
                        className="card shadow-sm rounded-4 px-3 py-2 scroll-container"
                        style={{
                          overflowX: "auto",
                          borderLeft: "10px solid #482807",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span
                              className="fw-bold text-secondary"
                              style={{
                                transform: "rotate(270deg)",
                                letterSpacing: "2px",
                              }}
                            >
                              {item?.number_plate
                                ? item.number_plate.slice(-4)
                                : "N/A"}
                            </span>
                          </div>
                          <div className="d-flex">
                            <div
                              className="d-flex flex-column pe-2"
                              style={{
                                width: "260px",
                                borderRight: "2px dashed rgb(103, 105, 105)",
                              }}
                            >
                              <div className="d-flex">
                                <Link
                                  className="text-primary fw-semibold"
                                  to={`/bus/${item.id}`}
                                >
                                  {item?.number_plate || "N/A"}
                                </Link>
                                {/* <span>
                                  <FaRegEdit className="ms-1 me-2" size={14} />
                                </span> */}
                                <span
                                  className={`ms-2 align-self-center rounded-pill ${getBusStatusBadge(
                                    item?.status
                                  )}`}
                                >
                                  {item?.status || "N/A"}
                                </span>
                              </div>
                              <span
                                className="text-secondary fw-medium"
                                style={{ fontSize: "0.8rem" }}
                              >
                                ({item?.model || "N/A"})
                              </span>
                            </div>
                            <div
                              className="d-flex flex-column ms-5"
                              style={{ width: "150px" }}
                            >
                              <span
                                className="text-primary fw-medium"
                                style={{ fontSize: "0.9rem" }}
                              >
                                Monthly Travel:
                              </span>
                              <span
                                className="text-secondary fw-medium"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {`${item?.monthly_travel_distance || "N/A"} km`}
                              </span>
                            </div>
                          </div>
                          <div
                            className="dual-progress-container"
                            style={{ minWidth: "200px" }}
                          >
                            <div>
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="d-flex align-items-center gap-1">
                                  <MdReduceCapacity
                                    fontSize={12}
                                    className="text-primary"
                                  />
                                  <span
                                    className="fw-medium text-dark"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    Occupied
                                  </span>
                                </span>
                                <span
                                  className="text-secondary fw-medium"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  {item?.occupied}/{item?.capacity} (
                                  {item?.capacity > 0
                                    ? (
                                        (item?.occupied / item?.capacity) *
                                        100
                                      ).toFixed(1)
                                    : "0.0"}
                                  %)
                                </span>
                              </div>
                              <div className="custom-progress">
                                <CustomTooltip
                                  title={`Occupied: ${item?.occupied}/${
                                    item?.capacity
                                  } (${
                                    item?.capacity > 0
                                      ? (
                                          (item?.occupied / item?.capacity) *
                                          100
                                        ).toFixed(1)
                                      : 0
                                  }%)`}
                                  arrow
                                >
                                  <div
                                    className={`progress-bars ${
                                      item?.capacity > 0
                                        ? (item.occupied / item.capacity) *
                                            100 >=
                                          90
                                          ? "bg-gradient-danger"
                                          : (item.occupied / item.capacity) *
                                              100 >=
                                            60
                                          ? "bg-gradient-warning"
                                          : "bg-gradient-primary"
                                        : "bg-gradient-secondary"
                                    }`}
                                    style={{
                                      width: `${
                                        item?.capacity > 0
                                          ? (item?.occupied / item?.capacity) *
                                            100
                                          : 0
                                      }%`,
                                    }}
                                  >
                                    <span
                                      className="bar-label"
                                      title={`${
                                        item?.capacity > 0
                                          ? (
                                              (item?.occupied /
                                                item?.capacity) *
                                              100
                                            ).toFixed(1)
                                          : 0
                                      }% full`}
                                    >
                                      {item?.occupied}/{item?.capacity}
                                    </span>
                                  </div>
                                </CustomTooltip>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex flex-column justify-content-start align-items-end px-2 h-100 ms-2">
                            <div className="d-flex justify-content-end w-100 gap-2 align-items-center">
                              <span
                                className={`badge rounded-pill text-bg-${
                                  item?.bus?.is_device_online
                                    ? "success-soft"
                                    : "danger-soft"
                                }`}
                              >
                                {item?.bus?.is_device_online
                                  ? "Online"
                                  : "Offline"}
                              </span>
                              <CustomTooltip
                                title="Refresh"
                                arrow
                                placement="top"
                              >
                                <span
                                  className="bus-refresh cursor-pointer"
                                  onClick={() => handleClickRefresh(item)}
                                >
                                  {refreshingBusId === item.id ? (
                                    <Spinner
                                      animation="border"
                                      variant="primary"
                                      size="sm"
                                    />
                                  ) : (
                                    <FiRefreshCw
                                      className="text-secondary"
                                      size={16}
                                    />
                                  )}
                                </span>
                              </CustomTooltip>
                            </div>
                            <div className="d-flex align-items-end gap-2 mt-1">
                              <CustomTooltip
                                title="Trips"
                                arrow
                                placement="bottom"
                              >
                                <span
                                  className="bus-action-button"
                                  onClick={() => {
                                    setSelectedActiontype("Trips");
                                    settSelectedBus(item);
                                    handlesidebar();
                                  }}
                                >
                                  <MdHistory
                                    className="text-secondary"
                                    size={17}
                                  />
                                </span>
                              </CustomTooltip>
                              <CustomTooltip
                                title="Trip Logs"
                                arrow
                                placement="bottom"
                              >
                                <span
                                  className="bus-action-button"
                                  onClick={() => {
                                    setSelectedActiontype("Trip Log");
                                    settSelectedBus(item);
                                    handlesidebar();
                                  }}
                                >
                                  <FaBusSimple
                                    className="text-secondary"
                                    size={17}
                                  />
                                </span>
                              </CustomTooltip>
                              <CustomTooltip
                                title="Active Passes"
                                arrow
                                placement="bottom"
                              >
                                <span
                                  className="bus-action-button"
                                  onClick={() => {
                                    setSelectedActiontype("Active Passes");
                                    settSelectedBus(item);
                                    handlesidebar();
                                  }}
                                >
                                  <FaRegUser
                                    className="text-secondary"
                                    size={17}
                                  />
                                </span>
                              </CustomTooltip>
                              <CustomTooltip
                                title="Replacement Logs"
                                arrow
                                placement="bottom"
                              >
                                <span
                                  className="bus-action-button"
                                  onClick={() => {
                                    setSelectedActiontype("Replacement Log");
                                    settSelectedBus(item);
                                    handlesidebar();
                                  }}
                                >
                                  <GoArrowSwitch
                                    className="text-secondary"
                                    size={17}
                                  />
                                </span>
                              </CustomTooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </Row>
            ) : (
              <div className="text-center my-3">No Data Found</div>
            )}
            <Modal
              show={modalVisible}
              onHide={handleToggleModal}
              centered
              className="custom-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title>Create Bus</Modal.Title>
              </Modal.Header>

              <Modal.Body className="py-4">
                {errormsg && (
                  <div className="alert alert-danger">{errormsg}</div>
                )}
                <div className="filter-sections">
                  <div className="mb-1">
                    <label htmlFor="number_plate" className="form-label">
                      Registration Number
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        errordata.number_plate ? "is-invalid" : ""
                      }`}
                      id="number_plate"
                      placeholder="Enter Registration Number"
                      value={addFormFields.number_plate}
                      onChange={(e) =>
                        setAddFormFields({
                          ...addFormFields,
                          number_plate: e.target.value.toUpperCase(),
                        })
                      }
                    />
                  </div>
                  <div className="mb-1">
                    <label htmlFor="capacity" className="form-label">
                      Capacity
                    </label>
                    <input
                      type="number"
                      className={`form-control ${
                        errordata.capacity ? "is-invalid" : ""
                      }`}
                      id="capacity"
                      placeholder="Enter Capacity"
                      value={addFormFields.capacity}
                      onChange={(e) =>
                        setAddFormFields({
                          ...addFormFields,
                          capacity: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="row mb-2 px-1">
                    <div className="col-6">
                      <label className="form-label">Monthly Distance</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errordata.monthly_travel_distance ? "is-invalid" : ""
                        }`}
                        placeholder="In kilometer"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setAddFormFields({
                              ...addFormFields,
                              monthly_travel_distance: value,
                            });
                          }
                        }}
                        value={addFormFields.monthly_travel_distance}
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Model</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errordata.model ? "is-invalid" : ""
                        }`}
                        placeholder="Model"
                        onChange={(e) =>
                          setAddFormFields({
                            ...addFormFields,
                            model: e.target.value,
                          })
                        }
                        value={addFormFields.model}
                      />
                      {/* <Select
                    className="react-select"
                    classNamePrefix="select"
                    options={modeloption}
                    onChange={(data) => {
                      setAddFormFields({
                        ...addFormFields,
                        model: data?.value || "",
                      });
                    }}
                    value={modeloption.filter(
                      (data) => data.value === addFormFields.model
                    )}
                  /> */}
                      {/* {errordata.model && (
                    <div className="text-danger">{errordata.model}</div>
                  )} */}
                    </div>
                  </div>
                  {/* <div>
                <div
                  className="form-check form-check-sm"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={"is_active"}
                    id={"is-active"}
                    checked={addFormFields.is_active}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        is_active: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor={"is-active"}>
                    Set Active
                  </label>
                </div>
              </div> */}
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="outline-secondary"
                  disabled={isAddSubmiting}
                  onClick={handleToggleModal}
                >
                  Cancel
                </Button>

                <Button
                  variant="primary"
                  disabled={isAddSubmiting}
                  onClick={handleadd}
                >
                  Create
                  {isAddSubmiting && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </Block>
        </div>
      )}
      <Offcanvas
        show={showSidebar}
        onHide={handlesidebar}
        placement="end"
        style={{
          width: width < 992 ? "100vw" : "650px",
        }}
      >
        <Offcanvas.Header className="py-2 border-bottom ps-2 pe-4" closeButton>
          <span
            className="fw-medium text-secondary"
            style={{ fontSize: "1.1rem" }}
          >
            {selectedActionType || "N/A"}
          </span>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 py-2">
          {actionComponents[selectedActionType?.toLowerCase()] || null}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "Employee",
});

export default connect(mapStateToProps)(BusListPage);
